/**
 * @generated SignedSource<<718edf4369dd1a2b73c35ee448a076cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ContentSubmissionStatus = "active" | "failed" | "passed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentSubmissionScreen_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly status: ContentSubmissionStatus;
  };
  readonly id: string;
  readonly learnOpportunity: {
    readonly " $fragmentSpreads": FragmentRefs<"NodeContainer_LearnOpportunityV2Fragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PaediaContentElement_ContentSubmissionFragment" | "contentSubmissionEnd_ContentSubmissionFragment">;
  readonly " $fragmentType": "ContentSubmissionScreen_ContentSubmissionFragment";
};
export type ContentSubmissionScreen_ContentSubmissionFragment$key = {
  readonly " $data"?: ContentSubmissionScreen_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionScreen_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentSubmissionScreen_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NodeContainer_LearnOpportunityV2Fragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubmissionEnd_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaediaContentElement_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "e979364c0cf209523f5de9b87856c1da";

export default node;
